<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre11" id="pgepubid00011"><a class="calibre1" id="Chapter_2">CHAPTER II.</a></h3>
<h4 class="calibre9 sigil_not_in_toc" id="pgepubid00012">MARJORY'S INDIGNATION.</h4>
<p class="calibre3">"Shameful!" Marjory said to herself with warmth after quitting
Harvey. "Without a word to Mr. Dalrymple or to Hermione!—and Mr.
Dalrymple always so good to him. He might at least have written,
even if he would not come home first. Such a cruel slight
to Mr. Dalrymple! I shall never, never like Harvey again."</p>
<p class="calibre3">Three minutes brought Marjory to the Rectory. She paused a moment
in the garden to ask of Sutton, "Has my father come in yet?"</p>
<p class="calibre3">"No, Miss Marjory, he ain't."</p>
<p class="calibre3">"Sutton, I wish you would take this basket of roses round
to Mrs. Pennant's. I promised to leave them for Miss Rivers, and I
don't feel now as if I could walk any farther."</p>
<p class="calibre3">Sutton rubbed his head dubiously.</p>
<p class="calibre3">"Well, now. Miss Marjory, I've got all this lot of diggin' to do: and
however it'll be done, if I'm a-gadding about at all hours for 'ee—"</p>
<p class="calibre3">"Never mind. I'll take the flowers myself," said the girl curtly.</p>
<p class="calibre3">She went straight indoors, blaming herself for the tone before she
crossed the threshold. Nobody was in the drawing-room. Books and work
lay about carelessly, not untidily. Marjory placed the basket on a
table, pulled off her hat, and threw herself down flat on a low
couch, having not even a pillow under her head. Though by no means
an invalid in habits, she suffered much, and had suffered for years,
from spinal weakness. The amount of work Marjory got through in her
home and in the Parish was astounding; but frequent short rests were
a necessity. "If I can just stop now and then to breathe, I do well
enough," she used to say patiently.</p>
<p class="calibre3">Ten minutes of entire stillness were followed by a light tread.
Marjory did not stir, except to lift her eyelids. A gentleman
entered, unmistakably her father. He was under medium height for a
man, and so thin as to be bony, with long fingers and pale skin.
His colouring was, however, more healthy than hers, and while it was
easily seen whence she had inherited her expressive eyes, the loose
hair was in him more scanty and was fast turning grey.</p>
<p class="calibre3">"Marjory resting!" he said in cheery tones, not as if surprised
or anxious.</p>
<p class="calibre3">"Yes, father!"</p>
<p class="calibre3">"What have you been doing?"</p>
<p class="calibre3">"I went to several cottages, and then to see Hermione. And on my way
back I met—"</p>
<p class="calibre3">"One moment. I must look at these letters the first thing."</p>
<p class="calibre3">Marjory seemed to have no objection to the delay. She shut her eyes
again and lay as before, flat and motionless, her arms straight down
by her sides. No other position so well suited the tired back;
but sometimes nothing less than the floor would do; and even then
Marjory had often an odd craving to get lower still as a relief
to her weariness. She never spoke of such sensations, however.</p>
<p class="calibre3">Presently a slight movement aroused her, and she found Mr. Fitzalan
to have taken a seat near.</p>
<p class="calibre3">"You have something to say," he observed.</p>
<p class="calibre3">"Harvey has come home."</p>
<p class="calibre3">"Yes!" It was a curious long syllable.</p>
<p class="calibre3">"Did you know? Have you seen him?"</p>
<p class="calibre3">"No. Sutton told me, as he doubtless told you."</p>
<p class="calibre3">"Sutton said nothing. I met Harvey. Ought I to call him
'Mr. Dalrymple'? I did at first, and he told me not. He was on his
way to the Hall. I am not sure that I should have known him, if he
had not stopped me; and yet he is very like his own self—the same
face and manner. But—father, he is married!"</p>
<p class="calibre3">Mr. Fitzalan gave one rapid glance up, after his daughter's
own fashion. He had been leaning a little forward, looking down.</p>
<p class="calibre3">"Married! Where and when?"</p>
<p class="calibre3">"I don't know. I heard nothing more. It made me angry, and I hurried
away. Of course he is old enough to decide for himself, and he is
quite independent, but still—still—Mr. Dalrymple has always been
so good to him—surely he ought to have heard beforehand! That,
at least, even if he might not say 'Yes' or 'No.' It seems cruel
to have done it in this way. And when one knows what Mr. Dalrymple's
great wish has been for so long—"</p>
<p class="calibre3">"Mr. Dalrymple's wish might have had a better hope of fulfilment,
if he had never spoken of it to Harvey."</p>
<p class="calibre3">"Yes, perhaps; but at least he need not have kept out of the way all
these years. Of course, a man must be free to choose for himself; and
Hermione might never have cared for him, even if he had wished
to marry her. I don't think she would be easily won. It is not that,
but his way of treating Mr. Dalrymple that I mind—putting him
to pain."</p>
<p class="calibre3">"Why, my dear Marjie!" for Marjory's eyes were full.</p>
<p class="calibre3">"I can't help it, father. I am cross, I know; but I can't bear
to think how Mr. Dalrymple will feel, when he has so longed for the
Hall to be always Hermione's home."</p>
<p class="calibre3">Mr. Fitzalan looked up again. "The old story; always trying to choose
for those we love! How can Mr. Dalrymple tell what will be
for Hermione's happiness?"</p>
<p class="calibre3">"No; only he does wish, and it is so natural to wish. And what I mind
is the disappointment coming so very suddenly—no time beforehand
for getting used to it. Harvey used to be so different. He never
would have done such a thing—once! It does seem to me so wrong and
unkind not to have spoken or written first. And when one has looked
up to a person for years—" Marjory's voice failed.</p>
<p class="calibre3">"Or to an idealised memory of a person," Mr. Fitzalan said quietly.
Few men in his place could have entered fully into Marjory's meaning;
but he knew her well, and recognised at once the dethroning of a
hero. His voice held the right mixture of the sympathetic and the
bracing as he continued, "This is not the first time that Harvey has
disappointed his friends."</p>
<p class="calibre3">"Oh, I know—people have blamed him for staying so long abroad, if he
were not obliged. But Hermione and I have always believed that he had
some really good reason. We never can forget what he used to be
with us, always so kind and gentle. And that is not usual, father.
Young men just leaving college don't generally care much for children
of eleven and thirteen."</p>
<p class="calibre3">"Perhaps not, generally. Harvey would do anything for anybody, if it
were not too much trouble."</p>
<p class="calibre3">Marjory made no answer, and her pale brow was knitted sorrowfully.
Mr. Fitzalan moved away to the table, where he began writing letters,
and presently Marjory followed him.</p>
<p class="calibre3">"Up again! Not rested yet, I think," he said, hardly pausing in his
rapid penmanship.</p>
<p class="calibre3">"I don't know. I must go out."</p>
<p class="calibre3">"What for?"</p>
<p class="calibre3">"Hermione asked me to leave these roses, with her love, at Mrs.
Pennant's."</p>
<p class="calibre3">"I saw Pennant just now on his rounds. Why could not Hermione leave
the flowers herself, or send a servant?"</p>
<p class="calibre3">"I don't know. She asked me."</p>
<p class="calibre3">"And you never say 'No' to Hermione?"</p>
<p class="calibre3">Marjory's lips parted in a smile. "I suppose not. I did not know
I should feel the heat so much. Besides, it is only down the village.
I will take the basket at once, and rest afterwards."</p>
<p class="calibre3">"No—I will see to the flowers."</p>
<p class="calibre3">"But your letters?"</p>
<p class="calibre3">"They shall wait. Duties never clash, my dear."</p>
<p class="calibre3">Mr. Fitzalan's left hand went detainingly to the basket-handle, while
his right, which had dropped the pen, drew her down upon a chair
close to his side. She laid her head against his shoulder, and there
was the sound of a long breath, half of pain, half of content. As a
rule these two were more reserved in their daily intercourse one with
the other than might have been expected. They loved deeply, and they
"pulled together well," as the saying is: yet their "hermit-spirits"
lived apart in locked chambers, seldom touching. Once in a way this
seclusion was broken through, but not often. Perhaps they were too
busy in outward life; perhaps too much alike in character.</p>
<p class="calibre3">"Poor little woman!" Mr. Fitzalan said musingly. "Always knocking
against hard corners in this rocky world of ours! But there's balm
for bruises, Marjie."</p>
<p class="calibre3">"Am I bruised?" and she tried to laugh; then whispered, "I hate to be
stupid."</p>
<p class="calibre3">"It is not stupidity. You are overstrained, doing everybody's work
for everybody. The fall of a wax image from its pedestal seems
a woeful event at such times. Yes—wax! How much do you know
of Harvey? Eight years ago he was a good-natured young fellow,
amusing himself with you two children. My dear, no doubt about that.
You were clever, and Hermione was pretty, and he had nothing to do.
He was kind, of course, but if you expect perfection in everybody
who is kind to you, I am afraid you are in for disappointments. Human
nature at its best is a very mixed concern. You don't look for
perfection, eh? No, not literally, perhaps; but you have a high
ideal, and you fancy now and then that you have found the ideal
embodied. Whereupon the embodiment falls short of the ideal, and
you—"</p>
<p class="calibre3">Marjory said only, "Yes," to this. Mr. Fitzalan changed his tone.</p>
<p class="calibre3">"You will never find it, except in One—in Christ. Human craving can
only be satisfied in Him. He alone comes up to the loftiest ideal,
and He alone can never disappoint our expectations. The best and
holiest of men and women do disappoint us more or less."</p>
<p class="calibre3">"Yes,—oh, I know, father."</p>
<p class="calibre3">"Knowing is not always believing, is it? After all, my experience
will not serve for you. Now go back to your couch, and have a quiet
hour. I will see to the roses."</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?2fe44e64